import { deepCopyOdds } from './deepCopyOdds';

export function deepCopyBet(bet) {
    return {
        id: bet.id,
        desc: bet.desc,
        groupingDesc: bet.groupingDesc,
        ranking: bet.ranking,
        parametrica: bet.parametrica,
        handicap: bet.handicap,
        tipoHandicap: bet.tipoHandicap,
        calculateHandicapDescription: bet.calculateHandicapDescription,
        handicapTableDesc: bet.handicapTableDesc,
        legabile: bet.legabile,
        odds: deepCopyOdds(bet.odds),
        forceAntepost: bet.forceAntepost,
        liveTimer: bet.liveTimer,
        mainLine: bet.mainLine,
        hideHandicap: bet.hideHandicap,
        handicapInfo: bet.handicapInfo,
        aggId: bet.aggId,
        aggDesc: bet.aggDesc
    };
}
